import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './components/auth/Login';
import Dashboard from './components/Dashboard';
import UserManagement from './components/UserManagement';
import EmailManagement from './components/EmailManagement';
import AttendanceManagement from './components/AttendanceManagement';
import EventManagement from './components/EventManagement';
import VideoVerification from './components/VideoVerification';
import ConnectionRequests from './components/ConnectionRequests';
import AnnouncementManagement from './components/AnnouncementManagement';
import NewsManagement from './components/NewsManagement';
import SponsorStoryManagement from './components/SponsorStoryManagement';
import ReportManagement from './components/ReportManagement';
import OrganizationManagement from './components/OrganizationManagement';
import WhatsAppInbox from './components/whatsapp/WhatsAppInbox';
import WhatsAppContacts from './components/whatsapp/WhatsAppContacts';
import WhatsAppBroadcasts from './components/whatsapp/WhatsAppBroadcasts';
import WhatsAppAnalytics from './components/whatsapp/WhatsAppAnalytics';
import WhatsAppSentMessages from './components/whatsapp/WhatsAppSentMessages';
import WhatsAppBilling from './components/whatsapp/WhatsAppBilling';
import WhatsAppIntegrations from './components/whatsapp/WhatsAppIntegrations';
import WhatsAppSettingsPage from './components/whatsapp/settings/WhatsAppSettingsPage';
import WhatsAppTemplates from './components/whatsapp/WhatsAppTemplates';
import WhatsAppConvoBot from './components/whatsapp/WhatsAppConvoBot';
import ProtectedRoute from './components/auth/ProtectedRoute';
import './App.css';
import './styles/whatsapp-theme.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="/home" element={
              <ProtectedRoute requiredAccess="dashboard">
                <Layout>
                  <Dashboard />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/users" element={
              <ProtectedRoute requiredAccess="users">
                <Layout>
                  <UserManagement />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/emails" element={
              <ProtectedRoute requiredAccess="emails">
                <Layout>
                  <EmailManagement />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/attendance" element={
              <ProtectedRoute requiredAccess="attendance">
                <Layout>
                  <AttendanceManagement />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/events" element={
              <ProtectedRoute requiredAccess="events">
                <Layout>
                  <EventManagement />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/videos" element={
              <ProtectedRoute requiredAccess="videos">
                <Layout>
                  <VideoVerification />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/connections" element={
              <ProtectedRoute requiredAccess="connections">
                <Layout>
                  <ConnectionRequests />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/announcements" element={
              <ProtectedRoute requiredAccess="announcements">
                <Layout>
                  <AnnouncementManagement />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/news" element={
              <ProtectedRoute requiredAccess="news">
                <Layout>
                  <NewsManagement />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/sponsor-stories" element={
              <ProtectedRoute requiredAccess="sponsor_stories">
                <Layout>
                  <SponsorStoryManagement />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/reports" element={
              <ProtectedRoute requiredAccess="reports">
                <Layout>
                  <ReportManagement />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/whatsapp" element={
              <ProtectedRoute requiredAccess="whatsapp">
                <Layout>
                  <WhatsAppInbox />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/whatsapp/contacts" element={
              <ProtectedRoute requiredAccess="whatsapp">
                <Layout>
                  <WhatsAppContacts />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/whatsapp/broadcasts" element={
              <ProtectedRoute requiredAccess="whatsapp">
                <Layout>
                  <WhatsAppBroadcasts />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/whatsapp/sent" element={
              <ProtectedRoute requiredAccess="whatsapp">
                <Layout>
                  <WhatsAppSentMessages />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/whatsapp/billing" element={
              <ProtectedRoute requiredAccess="whatsapp">
                <Layout>
                  <WhatsAppBilling />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/whatsapp/analytics" element={
              <ProtectedRoute requiredAccess="whatsapp">
                <Layout>
                  <WhatsAppAnalytics />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/whatsapp/settings" element={
              <ProtectedRoute requiredAccess="whatsapp">
                <Layout>
                  <WhatsAppSettingsPage />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/whatsapp/integrations" element={
              <ProtectedRoute requiredAccess="whatsapp">
                <Layout>
                  <WhatsAppIntegrations />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/whatsapp/templates" element={
              <ProtectedRoute requiredAccess="whatsapp">
                <Layout>
                  <WhatsAppTemplates />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/whatsapp/convobot" element={
              <ProtectedRoute requiredAccess="whatsapp">
                <Layout>
                  <WhatsAppConvoBot />
                </Layout>
              </ProtectedRoute>
            } />
            <Route path="/organization" element={
              <ProtectedRoute requireSuperAdmin requiredAccess="organization_management">
                <Layout>
                  <OrganizationManagement />
                </Layout>
              </ProtectedRoute>
            } />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
